import Cookies from 'js-cookie'

const hint = {
    _timeout: undefined,
    FADE_TIME: 400,
    url: undefined,
    ids: {
        container: 'hint-container',
        closeBtn: 'hint-close',
    },
    queue: [], // Fila de notificações pendentes
    isShowing: false, // Indica se há uma notificação sendo exibida no momento

    _removeListeners() {
        $('#' + hint.ids.closeBtn).off('click', hint.hideInstantly);
        $('#' + hint.ids.container).off('mouseout', hint.hideSlowly);
        $('#' + hint.ids.container).off('mouseover', hint._onmouseover);
    },

    _addListeners() {
        $('#' + hint.ids.closeBtn).click(hint.hideInstantly);
        $('#' + hint.ids.container).on('mouseout', hint.hideSlowly);
        $('#' + hint.ids.container).on('mouseover', hint._onmouseover);
        hint.hideSlowly();
    },

    _hideFn: () => {
        $('#' + hint.ids.container).fadeOut(hint.FADE_TIME, () => {
            hint.isShowing = false;
            hint.showNextHint();
        });
    },

    hideInstantly: () => {
        hint._removeListeners();
        hint.clearTimeout();
        $('#' + hint.ids.container).fadeOut(hint.FADE_TIME, () => {
            hint.isShowing = false;
            hint.showNextHint();
        });
    },

    hideSlowly: () => {
        hint.clearTimeout();
        hint._timeout = window.setTimeout(hint._hideFn, 10000);
    },

    clearTimeout: () => {
        if (hint._timeout !== undefined) {
            clearTimeout(hint._timeout);
            hint._timeout = undefined;
        }
    },

    getAllSeen: () => {
        const cookie = Cookies.get('dicas_vistas');
        if (cookie) {
            try {
                return JSON.parse(cookie);
            } catch (e) {
                return [];
            }
        }
        return [];
    },

    markAsSeenByUser: (id, tipo) => {
        if (tipo === "dica") {
            let dicasVistas = hint.getAllSeen();
            if (!dicasVistas.includes(id)) {
                dicasVistas.push(id);
                Cookies.set('dicas_vistas', JSON.stringify(dicasVistas));
                Cookies.set('data_ultima_dica_vista', new Date().toLocaleDateString());
            }
        }
    },

    init: (text, id, title, tipo, url = null) => {
        if (tipo === "dica") {
            let dicasVistas = hint.getAllSeen();
            if (dicasVistas.includes(id)) {
                return; // Se a dica já foi vista, não adiciona à fila
            }
        }

        hint.queue.push({url, text, id, title, tipo});

        if (!hint.isShowing) {
            if (!PaginaEproc.isTelaPequena()) {
                hint.showNextHint();
                hint.markAsSeenByUser();
            }
        }
    },

    showNextHint: () => {
        if (hint.queue.length > 0) {
            const nextHint = hint.queue.shift(); // Pega a próxima notificação
            hint._text = nextHint.text;
            hint._id = nextHint.id;
            hint._title = nextHint.title;
            hint.url = nextHint.url;
            hint.tipo = nextHint.tipo;

            hint._createOrUpdateContainer();
            hint._addListeners();
            hint.markAsSeenByUser(hint._id, hint.tipo); // Registra se for dica
            hint._restartSpinnerAnimation();
            hint._showHiddenHint();
            hint.isShowing = true;
        }
    },

    _showHiddenHint() {
        $('#' + hint.ids.container).fadeIn(hint.FADE_TIME);
    },

    _restartSpinnerAnimation() {
        let spinnerWrapper = $('#' + hint.ids.container).find('.pie-spinner-wrapper')[0];
        if (spinnerWrapper) {
            spinnerWrapper.classList.remove('anim-running');
            void spinnerWrapper.offsetWidth; // Força reflow
            spinnerWrapper.classList.add('anim-running');
        }
    },

    _createOrUpdateContainer() {
        let exists = document.getElementById(hint.ids.container) !== null;

        if (!exists) {
            hint._createContainer();
        } else {
            hint._updateContainer();
        }
    },

    _escapeHTML(str) {
        if (typeof str !== 'string') {
            return '';
        }
        return str
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    },

    _createContainer() {
        let id = hint._id;
        let text = hint._text;
        let title = hint._title;

        // Remove aspas duplas externas da URL antes de escapar
        let rawUrl = (hint.url === null) ? null : hint.url.replace(/^"+|"+$/g, '');

        let url = (rawUrl === null) ? null : this._escapeHTML(rawUrl);
        let strHintText = (url === null)
            ? `<span id="hint-text">${text}</span>`
            : `<span id="hint-text"><a href="${url}" target="_blank" rel="noopener noreferrer">${text}</a></span>`;

        $('body').append(`
            <div class="bootstrap-styles">
                <div id="hint-container" style="display: none;" data-hint-id="${id}" class="alert shadow-sm">
                    <div class="d-flex">
                        <div class="d-flex align-items-center">
                            <div id="hint-icon" class="align-items-center">
                                <i class="material-icons">emoji_objects</i>
                            </div>
                        </div>
                        <div class="align-self-center">
                            <div>
                                <span id="hint-title" class="font-weight-bold">${title}</span><br>
                                ${strHintText}
                            </div>
                        </div>
                        <div class='timer-with-button align-self-center'>
                            <div class="pie-spinner-wrapper anim-running">
                                <div class="spinner pie"></div>
                                <div class="filler pie"></div>
                                <div class="mask"></div>
                            </div>                        
                            <button type="button" id="hint-close" class="close" aria-label="Fechar" style="z-index: 400;color: black;position: absolute;"><span aria-hidden="true">&times;</span></button>
                        </div>
                    </div>
                </div>                    
            </div>
        `);
    },

    _updateContainer() {
        document.getElementById('hint-text').innerHTML = hint._text;
        document.getElementById('hint-title').innerHTML = hint._title;
        document.getElementById(hint.ids.container).setAttribute('data-hint-id', hint._id);
    }
};

export default hint;